export default __webpack_public_path__ + "static/media/company-logo3.e3bde420.png";